import { useContext, useRef, useState } from "react"
import { JSONSchema7 } from "json-schema"
import { SchemaForm, SchemaFormRefProps, ToolsContext } from "resha"

import { SuperTaskWorkerModel } from "../../../../../../../../../../../../Models/API/SuperTaskModel"
import { MultiSchemaField } from "../../../../../../../../../../../Common/SchemaForm/Fields"
import { SchemaFormModal } from "../../../../../../../../../../../Common/SchemaForm/Modals"
import { uiSchema } from "./uiSchema"

export enum WorkerModalType {
    New = "new",
    Edit = "edit"
}

type WorkerModalProps = {
    onClose: () => void
    onSubmit: (newField: SuperTaskWorkerModel) => void
    schema: JSONSchema7
    value?: SuperTaskWorkerModel
    index?: number
    type?: WorkerModalType
}

export const WorkerModal = ({
    onClose,
    onSubmit,
    schema,
    value,
    type = WorkerModalType.New,
    index
}: WorkerModalProps) => {
    const schemaRef = useRef<SchemaFormRefProps>(null)
    const tools = useContext(ToolsContext)

    const [state, setState] = useState<SuperTaskWorkerModel | undefined>(value)

    const handleChange = (value: unknown) => {
        setState(value as SuperTaskWorkerModel)
    }

    const handleSubmit = () => {
        const form = schemaRef.current
        const validationResult = form?.validate([state], schema)

        if (!validationResult?.errors.length && state) {
            onSubmit(state)
            onClose()
        }
    }

    return (
        <SchemaFormModal
            title={
                type === WorkerModalType.Edit ? "Edit worker" : "Add new worker"
            }
            onClose={onClose}
            onSubmit={handleSubmit}
            submit={{
                label:
                    type === WorkerModalType.Edit
                        ? "Update worker"
                        : "Add worker"
            }}
        >
            <SchemaForm
                {...tools}
                liveValidate
                ref={schemaRef}
                schema={{
                    ...(schema?.items as JSONSchema7),
                    definitions: schema.definitions,
                    type: "object",
                    title: "Worker type"
                }}
                additionalFields={{
                    AnyOfField: MultiSchemaField
                }}
                formData={state}
                uiSchema={uiSchema}
                onChange={handleChange}
            />
        </SchemaFormModal>
    )
}
